import JIO from '../assets/png/JIO.png'
import BLUEOCEAN from '../assets/png/Blue Ocean.png'

export const experienceData = [
    {
        id: 1,
        image:BLUEOCEAN,
        company: 'Blu Ocean Innovations Pvt Ltd',
        jobtitle: 'Frontend Web Developer Intern ',
        startYear: 'Jan',
        endYear: 'March (2022)',
        link: 'https://drive.google.com/file/d/1lGNdqETI2kEGocNpqVBPVpCebdLKTQt0/view?usp=sharing'
    },
    {
        id: 2,
        image: JIO,
        company: 'Reliance Jio Infocomm LTD',
        jobtitle: 'Assistant Manager (GET - SDE) ',
        startYear: '2023',
        endYear: 'Current',
        link: 'https://www.jio.com/'
    },
    
]